import { useState, useEffect } from "react";
import { api } from "../api";
import { roleConfig } from "../constants";
import Card from "./ui/Card";
import Input from "./ui/Input";
import Select from "./ui/Select";
import Btn from "./ui/Btn";
import Modal from "./ui/Modal";

export default function UsersMgmt({ reviewers, toast, user }) {
  const isReadOnly = user?.role === "auditor";
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({
    username: "",
    password: "",
    full_name: "",
    role: "reviewer",
    reviewer_id: "",
    active: true,
  });

  const load = async () => {
    try {
      const r = await api("/users");
      setUsers(r || []);
    } catch {}
  };

  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    if (!form.full_name || (!form.password && modal === "add")) {
      toast("يرجى ملء الحقول المطلوبة", "warning");
      return;
    }
    try {
      if (modal === "add")
        await api("/users", {
          method: "POST",
          body: {
            ...form,
            reviewer_id: form.reviewer_id ? parseInt(form.reviewer_id) : null,
          },
        });
      else
        await api(`/users/${form.id}`, {
          method: "PUT",
          body: {
            username: form.username || undefined,
            full_name: form.full_name,
            role: form.role,
            reviewer_id: form.reviewer_id
              ? parseInt(form.reviewer_id)
              : null,
            active: form.active,
            password: form.password || undefined,
          },
        });
      toast("✅ تم الحفظ");
      setModal(null);
      load();
    } catch (e) {
      toast("خطأ: " + e.message, "error");
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <h2
          style={{
            fontSize: 20,
            fontWeight: 800,
            margin: 0,
            color: "#f1f5f9",
          }}
        >
          🔐 المستخدمون
        </h2>
        {!isReadOnly && (
          <Btn
            onClick={() => {
              setForm({
                username: "",
                password: "",
                full_name: "",
                role: "reviewer",
                reviewer_id: "",
                active: true,
              });
              setModal("add");
            }}
            color="#22c55e"
          >
            + إضافة
          </Btn>
        )}
      </div>
      <Card>
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: 12,
            }}
          >
            <thead>
              <tr style={{ background: "#0f172a" }}>
                {["المستخدم", "الاسم", "الدور", "المراجع", "الحالة", "⚙️"].map(
                  (h) => (
                    <th
                      key={h}
                      style={{
                        padding: "8px 10px",
                        color: "#64748b",
                        textAlign: "right",
                        borderBottom: "1px solid #1e293b",
                      }}
                    >
                      {h}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {users.map((u, i) => (
                <tr
                  key={u.id}
                  style={{
                    borderBottom: "1px solid #0f172a",
                    background: i % 2 ? "#ffffff03" : "transparent",
                  }}
                >
                  <td
                    style={{
                      padding: "7px 10px",
                      color: "#38bdf8",
                      fontWeight: 700,
                    }}
                  >
                    {u.username}
                  </td>
                  <td style={{ padding: "7px 10px", color: "#f1f5f9" }}>
                    {u.full_name}
                  </td>
                  <td style={{ padding: "7px 10px" }}>
                    <span
                      style={{
                        background: `${roleConfig[u.role]?.color || "#64748b"}22`,
                        color: roleConfig[u.role]?.color || "#64748b",
                        borderRadius: 5,
                        padding: "2px 7px",
                        fontSize: 10,
                        fontWeight: 700,
                      }}
                    >
                      {roleConfig[u.role]?.label || u.role}
                    </span>
                  </td>
                  <td
                    style={{
                      padding: "7px 10px",
                      color: "#94a3b8",
                      fontSize: 11,
                    }}
                  >
                    {u.reviewer_name || "—"}
                  </td>
                  <td style={{ padding: "7px 10px" }}>
                    <span
                      style={{
                        background: u.active ? "#052e16" : "#1c0303",
                        color: u.active ? "#22c55e" : "#ef4444",
                        borderRadius: 5,
                        padding: "2px 7px",
                        fontSize: 10,
                      }}
                    >
                      {u.active ? "نشط" : "موقوف"}
                    </span>
                  </td>
                  <td style={{ padding: "7px 10px" }}>
                    {!isReadOnly && (
                      <Btn
                        size="sm"
                        color="#38bdf8"
                        onClick={() => {
                          setForm({
                            ...u,
                            password: "",
                            reviewer_id: u.reviewer_id || "",
                          });
                          setModal("edit");
                        }}
                      >
                        تعديل
                      </Btn>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
      {modal && (
        <Modal
          title={modal === "add" ? "إضافة مستخدم" : "تعديل مستخدم"}
          onClose={() => setModal(null)}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 13 }}>
            <Input
              label="اسم المستخدم"
              value={form.username}
              onChange={(v) => setForm((f) => ({ ...f, username: v }))}
              required={modal === "add"}
            />
            <Input
              label={
                modal === "add"
                  ? "كلمة المرور"
                  : "كلمة المرور الجديدة (فارغ = لا تغيير)"
              }
              type="password"
              value={form.password}
              onChange={(v) => setForm((f) => ({ ...f, password: v }))}
            />
            <Input
              label="الاسم الكامل"
              value={form.full_name}
              onChange={(v) => setForm((f) => ({ ...f, full_name: v }))}
              required
            />
            <Select
              label="الدور"
              value={form.role}
              onChange={(v) => setForm((f) => ({ ...f, role: v }))}
              options={[
                { value: "reviewer", label: "👤 مراجع" },
                { value: "viewer", label: "📄 عرض التقارير فقط" },
                { value: "auditor", label: "👁️ مراقب (قراءة كاملة)" },
                { value: "supervisor", label: "🔧 مشرف" },
                { value: "admin", label: "👑 مدير" },
              ]}
            />
            {form.role === "reviewer" && (
              <Select
                label="ربط بمراجع"
                value={form.reviewer_id}
                onChange={(v) => setForm((f) => ({ ...f, reviewer_id: v }))}
                options={reviewers.map((r) => ({
                  value: r.id,
                  label: r.name,
                }))}
              />
            )}
            {modal === "edit" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <input
                  type="checkbox"
                  checked={form.active}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, active: e.target.checked }))
                  }
                />
                <label style={{ color: "#94a3b8", fontSize: 13 }}>
                  حساب نشط
                </label>
              </div>
            )}
            <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
              <Btn onClick={save} color="#22c55e" size="lg">
                💾 حفظ
              </Btn>
              <Btn onClick={() => setModal(null)} color="#64748b" size="lg">
                إلغاء
              </Btn>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
